import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Table } from "react-bootstrap";
import { colValue, compName, month } from "../../../../utils/constant";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import WidgetDetailModal from "../../WidgetDetailModal";
import WidgetNote from "../../WidgetNote";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";
const ThreeDayForecastChange = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const yearsArr = [
        ...commonService.getPastYearForDropDown(10),
        ...commonService.getFutureYearForDropDown(10),
        new Date().getFullYear(),
    ]?.sort(function (a, b) {
        return a - b;
    });
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [col, setCol] = useState();
    const tableData = [
        { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
        { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
    ];
    let occ = 0,
        rms = 0,
        adr = 0,
        rev = 0;

    const [threeDayForecastChangeData, setThreeDayForecastChangeData] =
        useState(null);
    const [loading, setLoading] = useState(false);
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const getThreeDayForecastChangeDetail = async () => {
        setLoading(true);
        let threeDayForecastChangeResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.PICK_UP.THREE_DAY_FORECAST_CHANGE,
                body: {
                    AsOfDate: para?.asOfDate,
                    year: selectedYear,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, threeDayForecastChangeResponse);

        if (response?.isValidate) {
            setThreeDayForecastChangeData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setThreeDayForecastChangeData(tableData);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (api === 0) {
            setThreeDayForecastChangeData(tableData);
        } else {
            if (para?.asOfDate) {
                getThreeDayForecastChangeDetail();
            }
        }
    }, [selectedYear, para?.asOfDate]);
    const [tblids, settblids] = useState({
        tblThreeDayForecastChange: commonService.GenerateGUID(),
    });
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.tblThreeDayForecastChange} .perbackground-rev`
    );

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    {/* <Button className="heading-menu-btns" type="button">
                        <img
                            src={NoteIcon}
                            alt="menuIcon"
                            onClick={() => {
                                setShowNoteSidebar(true);
                            }}
                        />
                    </Button> */}
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("ThreeDayForecastChange", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.tblThreeDayForecastChange,
                                    "Three Day Forecast Change",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("ThreeDayForecastChange", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.threeDayForecastChange,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("ThreeDayForecastChange", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.tblThreeDayForecastChange}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.tblThreeDayForecastChange,
                                    // "Three Day Forecast Change"
                                    `${para?.propertyCode}-Three Day Forecast Change-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable ">
                <div className="stripped__table">
                    <Table responsive id={tblids.tblThreeDayForecastChange}>
                        <thead>
                            <tr>
                                <th>
                                    <div>
                                        <Form.Select id={commonService.generateGlobalClickTrackerID("ThreeDayForecastChange", "month", propertyCode)}
                                            value={selectedYear}
                                            onChange={(e) => {
                                                setSelectedYear(e.target.value);
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {yearsArr?.map((item, index) => (
                                                <option key={index} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <span style={{ display: "none" }}>{selectedYear}</span>
                                    </div>
                                </th>
                                <th colSpan={4} className="text-center">
                                    Three Day Forecast Change
                                </th>
                            </tr>
                            <tr>
                                <th>Month</th>
                                <th>OCC</th>
                                <th className="text-center">RMS</th>
                                <th className="text-end">ADR</th>
                                <th className="text-end">REV</th>
                            </tr>
                        </thead>
                        <tbody>
                            {api === 0 ? (
                                threeDayForecastChangeData?.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <tr key={index} className="shadowOnHover">
                                            <td>{item?.month}</td>
                                            <td>{item?.occ}%</td>
                                            <td className="text-center">{item?.rms}</td>
                                            <td className="text-end">${item?.adr}</td>
                                            <td
                                                className="text-end perbackground perbackground-rev"
                                                value={item?.rev}
                                            >
                                                ${item?.rev}
                                            </td>
                                        </tr>
                                        {index === 11 && (
                                            <tr className="shadowOnHover">
                                                <td className="boldTd">Total</td>
                                                <td className="boldTd">0%</td>
                                                <td className="boldTd text-center">0</td>
                                                <td className="boldTd text-end">$0</td>
                                                <td className="boldTd text-end">$0</td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : loading ? (
                                <tr style={{ height: "80px", position: "relative" }}>
                                    <Loader />
                                </tr>
                            ) : (
                                threeDayForecastChangeData &&
                                month?.map((item, index) => {
                                    let findMonthData = threeDayForecastChangeData?.filter(
                                        (x) => x.month?.trim() === item
                                    );

                                    occ =
                                        occ +
                                        (findMonthData?.[0]?.occ
                                            ? parseFloat(findMonthData?.[0]?.occ)
                                            : 0);
                                    rms =
                                        rms + findMonthData?.[0]?.rms ? findMonthData?.[0]?.rms : 0;
                                    adr =
                                        adr +
                                        (findMonthData?.[0]?.adr
                                            ? parseFloat(findMonthData?.[0]?.adr)
                                            : 0);
                                    rev =
                                        rev +
                                        (findMonthData?.[0]?.rev
                                            ? parseFloat(findMonthData?.[0]?.rev)
                                            : 0);

                                    return (
                                        <React.Fragment key={index}>
                                            <tr key={index} className="shadowOnHover">
                                                <td>{item}</td>
                                                <td>
                                                    {findMonthData?.[0]?.occ
                                                        ? Math.round(findMonthData?.[0]?.occ)
                                                        : 0}
                                                    %
                                                </td>
                                                <td className="text-center">
                                                    {findMonthData?.[0]?.rms
                                                        ? commonService.formateRoom(findMonthData?.[0]?.rms)
                                                        : 0}
                                                </td>
                                                <td className="text-end">
                                                    {findMonthData?.[0]?.adr
                                                        ? commonService.formateAmount(
                                                            Math.round(findMonthData?.[0]?.adr)
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                                <td
                                                    className="text-end perbackground perbackground-rev"
                                                    value={findMonthData?.[0]?.rev}
                                                >
                                                    {findMonthData?.[0]?.rev
                                                        ? commonService.formateAmount(
                                                            Math.round(findMonthData?.[0]?.rev)
                                                        )
                                                        : commonService.formateAmount(0)}
                                                </td>
                                            </tr>
                                            {index === 11 && (
                                                <tr key={index} className="shadowOnHover">
                                                    <td className="boldTd">Total</td>
                                                    <td className="boldTd">
                                                        {occ !== 0 ? Math.round(occ / 12) : 0}%
                                                    </td>
                                                    <td className="boldTd text-center">{commonService.formateRoom(rms)}</td>
                                                    <td className="boldTd text-end">
                                                        {rev !== 0 && rms !== 0
                                                            ? commonService.formateAmount(parseInt(rev / rms))
                                                            : commonService.formateAmount(0)}
                                                    </td>
                                                    <td className="boldTd text-end">
                                                        {commonService.formateAmount(Math.round(rev))}
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"ThreeDayForecastChange"} />
            )}

            {/* {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )} */}
            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default ThreeDayForecastChange;
